import type { RentalSelection } from '@/modules/rentals/utils/rental-selection.ts'
import type { BookingDuration } from '@/types'

export interface BookingState {
  step: number
  selectedDateIdx: number
  selectedTime: string | null
  selectedDuration: BookingDuration
  selectedCourtId: string | null
  selectedSportId: string | null
  showModal: boolean
  notes: string
  rentalSelection: RentalSelection
  rentalTermHash: string | null
  hasEquipmentStep: boolean
}

const DEFAULT_DURATION: BookingDuration = 60

export const INITIAL_BOOKING: BookingState = {
  step: 1,
  selectedDateIdx: 0,
  selectedTime: null,
  selectedDuration: DEFAULT_DURATION,
  selectedCourtId: null,
  selectedSportId: null,
  showModal: false,
  notes: '',
  rentalSelection: {},
  rentalTermHash: null,
  hasEquipmentStep: false,
}

const RENTAL_INVALIDATING_KEYS = [
  'selectedDateIdx',
  'selectedTime',
  'selectedDuration',
  'selectedSportId',
  'selectedCourtId',
] as const satisfies readonly (keyof BookingState)[]

export function mergeBookingState(
  prev: BookingState,
  partial: Partial<BookingState>,
): BookingState {
  const next = { ...prev, ...partial }
  const changesSchedule = RENTAL_INVALIDATING_KEYS.some(
    (key) => key in partial && partial[key] !== prev[key],
  )
  if (!changesSchedule) {
    return next
  }

  return {
    ...next,
    rentalSelection: 'rentalSelection' in partial ? next.rentalSelection : {},
    rentalTermHash: 'rentalTermHash' in partial ? next.rentalTermHash : null,
  }
}
